/**
 * 允许的图片格式
 */
export const ALLOW_PICTURE_EXT = ['png', 'jpg', 'jpeg'];

/**
 * 允许的视频格式
 */
export const ALLOW_VIDEO_EXT = ['mp4', 'mov'];

/**
 * 允许的音频格式
 */
export const ALLOW_AUDIO_EXT = ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'flac'];

/**
 * 单文件最大不超过：1G
 */
export const MAX_FILE_SIZE = 1 * 1024 * 1024 * 1024;

/**
 * 最大文件上传数量：50
 */
export const MAX_UPLOAD_COUNT = 50;
